/*
 * @Author: QIYE
 * @Date: 2020-06-08 17:28:28
 * @LastEditors: qiye
 * @LastEditTime: 2020-07-01 16:13:26
 */


const state = {
  activeindex: '1' ,

}
const mutations = {

  SET_ACTIVEINDEX: (state, activeindex) => {
    state.activeindex = activeindex
  },


}

// const actions = {

// }

export default {
  state,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js